import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import AddButton from '../../core/AddButton';
import PrimaryButton from '../../core/PrimaryButton';
import { globalStyles } from '../../core/style/gstheme';
import SelectResourceLink from './SelectResourceLink';

const styles = Object.assign({}, globalStyles);

class SelectResourcesDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false
        };
        this.cancellable = null;
    }

    handleClickOpen = () => this.setState({ open: true });

    exitAddResource = () => this.setState({ open: false });

    addResource = (id) => this.props.addResource(id);

    render() {

        const { classes, defaultLang, resources, graph, title, buttonTitle, addResource, setHeight } = this.props;

        return (
            <React.Fragment>
                <AddButton dataTest="add-resource" onClick={() => this.handleClickOpen()} title={buttonTitle || "Add resources"} />
                <Dialog
                    data-test="select-resource-dialog"
                    maxWidth="md"
                    fullWidth
                    classes={{
                        paper: classes.paper,
                        paperWidthMd: classes.mediumDialog
                    }}
                    className={classes.dialog} open={this.state.open} onClose={this.exitFindResource} aria-labelledby="find-resource-dialog-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="find-class-dialog-title">{title || "Add Resources"}</DialogTitle>
                    <DialogContent data-test="selectable-resources" style={{
                        ...(setHeight) && { height: 440 },
                        maxHeight: 440
                    }}>
                        {
                            [...resources].sort().map((result, index) => {
                                return <SelectResourceLink
                                    id={result}
                                    key={result}
                                    data-test={"list-item-" + index}
                                    selectResource={() => addResource(result)}
                                    handleNotAvailable={true}
                                    defaultLang={defaultLang}
                                    viewLang={defaultLang}
                                    graph={graph} />;
                            })}
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <PrimaryButton onClick={this.exitAddResource}>Close</PrimaryButton>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

SelectResourcesDialog.defaultProps = {
    resources: [],
    setHeight: true
};

SelectResourcesDialog.propTypes = {
    classes: PropTypes.object,
    setHeight: PropTypes.bool,
    title: PropTypes.string,
    buttonTitle: PropTypes.string,
    resources: PropTypes.array,
    defaultLang: PropTypes.string.isRequired,
    addResource: PropTypes.func.isRequired,
    graph: PropTypes.string.isRequired
};

export default withStyles(styles)(SelectResourcesDialog);